import { ArrayInput, required, useTranslate } from "react-admin";
import React from "react";
import useValidation, { maxDate, minDate } from "../useValidation";
import { MYDateInput } from "../../component/input";
import SimpleFormIterator from "../../component/form/SimpleFormIterator";
import {
  DebouncedTextInput,
  Group,
  GroupTitle,
  useFieldLabel,
} from "ra-friendsofbabba";
import { useFormState } from "react-final-form";

const DeliverablesInput = ({ listIndexRenderer, ...props }) => {
  const translate = useTranslate();
  const fieldLabel = useFieldLabel({
    resource: "executive-project-work-package-deliverables",
  });
  const form = useFormState();
  const { min } = useValidation(form);
  return (
    <Group wrapper>
      <GroupTitle
        title={translate("resources.executive-projects.fields.deliverables")}
        subTitle={translate(
          "resources.executive-project-work-package-deliverables.help"
        )}
      />
      <ArrayInput {...props} label={false}>
        <SimpleFormIterator
          perPage={20}
          showPagination={false}
          listIndexRenderer={listIndexRenderer}
        >
          <MYDateInput
            source="release_date"
            label={fieldLabel("release_date", false)}
            min={min}
            initialValue={min.format("YYYY-MM-DD")}
            validate={[required(), minDate(), maxDate()]}
            lg={3}
            md={4}
            sm={6}
          />

          <DebouncedTextInput
            fullWidth
            source="title"
            label={fieldLabel("title")}
            maxLength={200}
            validate={required()}
          />

          <DebouncedTextInput
            fullWidth
            source="description"
            label={fieldLabel("description")}
            maxLength={1500}
            multiline
            validate={required()}
          />
        </SimpleFormIterator>
      </ArrayInput>
    </Group>
  );
};
export default DeliverablesInput;
